<template>
    <v-card class="product-review-card">
        <v-card-title class="pl-0">
            <v-list-tile class="product-review-header">
                <v-list-tile-avatar size="66" class="pr-2">
                    <v-img :src="'/media/' + review.reviewer_image"/>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-title class="product-review-title font-weight-bold">
                        {{ review.customer_name }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="product-review-subtitle">
                        {{ review.reviewer_age }}
                    </v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-card-title>

        <v-card-text class="product-review-title subheading pt-0">
            {{ review.text }}
        </v-card-text>
    </v-card>
</template>

<style lang="stylus" scoped>
@import '../../stylus/variables/product-reviews.styl';

.product-review-header {
    .v-list__tile {
        height: auto !important;
    }
}

.product-review-title {
    color: $product-review-main-text-color;
}

.product-review-subtitle {
    color: $product-review-secondary-text-color;
}

.product-review-card {
    border-radius: 4px;
}
</style>

<script>
export default {
    name: 'ProductReviewCard',
    props: [
        'review',
    ],
};
</script>